import { getAppointmentFetchConfigKey } from "@elixir/utils";
import { useQuery } from "@tanstack/react-query";
import { getIdb } from "../../utils/bridges/methods";
import dateFormat from "dateformat";
import useQueueStore from "../../stores/queue-store";
type AppointmentLastUpdatedAtArgs = {
  clinicId: string;
  date: Date;
};

function useGetAppointmentLastUpdatedAt({
  clinicId,
  date,
}: AppointmentLastUpdatedAtArgs) {
  const isSyncing = useQueueStore((state) => state.isSyncing);

  return useQuery({
    queryFn: () => getAppointmentLastUpdatedAt({ clinicId, date }),
    queryKey: getAppointmentLastUpdatedAtKeys({ clinicId, date }),
    staleTime: Infinity,
    enabled: !isSyncing,
  });
}

async function getAppointmentLastUpdatedAt({
  clinicId,
  date,
}: AppointmentLastUpdatedAtArgs): Promise<Date | undefined> {
  const lastFetch = await getIdb()
    .misc.where("key")
    .equals(getAppointmentFetchConfigKey({ clinicId, date }))
    .first();

  return lastFetch?.lastUpdatedAt;
}
export function getAppointmentLastUpdatedAtKeys({
  clinicId,
  date,
}: AppointmentLastUpdatedAtArgs) {
  return ["apt-last-updated", clinicId, dateFormat(date, "yyyy-mm-dd")];
}

export default useGetAppointmentLastUpdatedAt;
